<template>
  <div class="home">
    <cover />
    <residence />
    <office />
    <conference />
    <contact />
    <bottom />
  </div>
</template>

<script>
import cover from '../components/cover'
import residence from '../components/residence'
import office from '../components/office'
import conference from '../components/conference'
import contact from '../components/contact'
import bottom from '../components/bottom'

export default {
  name: 'home',
  components: {
    cover,
    residence,
    office,
    conference,
    contact,
    bottom
  }
}
</script>

<style lang="scss">
@import url(//fonts.googleapis.com/earlyaccess/notosansthaana.css);

</style>
